// components/ResultsPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuiz } from '../context/QuizContext';

const ResultsPage = () => {
  const { state, dispatch } = useQuiz();
  const navigate = useNavigate();

  const handleRestart = () => {
    dispatch({ type: 'RESET_QUIZ' });
    navigate('/');
  };

  if (!state.quizCompleted) {
    navigate('/');
    return null;
  }

  const totalQuestions = 10; // Should match your actual questions count
  const percentage = (state.score / (totalQuestions * 10)) * 100;

  return (
    <div className="results-page">
      <div className="results-container">
        <h1>Quiz Results</h1>
        
        <div className="results-card">
          <div className="result-header">
            <h2>Quiz Completed!</h2>
            <div className={`score-circle ${percentage >= 60 ? 'pass' : 'fail'}`}>
              <span className="score-percent">{percentage.toFixed(1)}%</span>
            </div>
          </div>

          <div className="results-details">
            <div className="detail-row">
              <span>Student Name:</span>
              <span>{state.studentInfo?.name}</span>
            </div>
            <div className="detail-row">
              <span>Student ID:</span>
              <span>{state.studentInfo?.studentId}</span>
            </div>
            <div className="detail-row">
              <span>Email:</span>
              <span>{state.studentInfo?.email}</span>
            </div>
            <div className="detail-row">
              <span>Score:</span>
              <span>{state.score} / {totalQuestions * 10}</span>
            </div>
            <div className="detail-row">
              <span>Warnings:</span>
              <span className={state.warnings > 0 ? 'warning-text' : ''}>
                {state.warnings} / 3
              </span>
            </div>
            <div className="detail-row">
              <span>Time Started:</span>
              <span>{state.startTime?.toLocaleString()}</span>
            </div>
            <div className="detail-row">
              <span>Time Completed:</span>
              <span>{state.endTime?.toLocaleString()}</span>
            </div>
            <div className="detail-row">
              <span>Duration:</span>
              <span>
                {state.startTime && state.endTime
                  ? `${Math.round((state.endTime - state.startTime) / 1000 / 60)} minutes`
                  : 'N/A'}
              </span>
            </div>
          </div>

          <div className="result-message">
            {percentage >= 60 ? (
              <p className="success">Congratulations! You passed the quiz.</p>
            ) : (
              <p className="fail">You did not pass. Better luck next time.</p>
            )}
          </div>

          <button onClick={handleRestart} className="btn-primary">
            Take Another Quiz
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultsPage;